import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

import { ErrorFallbackBase } from "@/components/error/ErrorFallbackBase";

export function AdminErrorFallback() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  return (
    <div className="flex h-full w-full items-center justify-center p-4">
      <ErrorFallbackBase
        title={t("common.errors.admin.title")}
        description={t("common.errors.admin.description")}
        icon={<AlertTriangle className="h-5 w-5 text-destructive" />}
        primaryAction={{
          label: t("common.errors.admin.reload"),
          onClick: () => window.location.reload(),
        }}
        secondaryAction={{
          label: t("common.errors.admin.goDashboard"),
          onClick: () => navigate("/admin"),
          variant: "outline",
        }}
      />
    </div>
  );
}
